import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	new: {
		backgroundColor: colors.green[100],
		color: colors.green[700],
		fontWeight: 700,
		height: theme.spacing(2.5),
		"& .MuiChip-label": {
			fontSize: theme.typography.pxToRem(10)
		}
	},
	upcoming: {
		backgroundColor: colors.purple[100],
		color: colors.purple[700],
		fontWeight: 700,
		height: theme.spacing(2.5),
		"& .MuiChip-label": {
			fontSize: theme.typography.pxToRem(10)
		}
	}
}))

export default useStyles
